import React, { useState, useMemo, useEffect } from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    Dialog, DialogBody,
    Typography,
} from "@material-tailwind/react";
import { ClockLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../context';
import { useApi } from '../../hooks/useApi';
import CalendarAdvance from '../../components/calenderAdvance';

const AdvancedBookingsMonth = () => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const { fetchAccessToken, defaultHotel } = useUserContext();
    const { getBookings } = useApi();
    const [bookings, setBookings] = useState([]);

    const handleMonthChange = (newMonth) => {
        setSelectedMonth(newMonth);
    };

    useEffect(() => {
        let getBookingsInternal = async () => {
            if (!defaultHotel) {
                return;
            }
            setIsLoading(true);
            try {
                const accessToken = await fetchAccessToken();
                const startTime = getEpoch(getStartOfMonth(selectedMonth), "00:00");
                const endTime = getEpoch(getEndOfMonth(selectedMonth), "23:59");
                const data = await getBookings(defaultHotel, startTime, endTime, accessToken);
                if (data && data.length) {
                    setBookings(data);
                }
                else {
                    setBookings([]);
                }
            } catch (error) {
                console.error(error);
            }
            finally {
                setIsLoading(false);
            }
        }

        if (defaultHotel) {
            getBookingsInternal();
        }
    }, [defaultHotel, selectedMonth]);

    function getStartOfMonth(date) {
        const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
        return startDate;
    }

    function getEndOfMonth(date) {
        const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return endDate;
    }

    function getEpoch(date, time, seconds = 0) {
        const [hours, minutes] = time.split(':').map(Number);
        const combinedDate = new Date(date);
        combinedDate.setHours(hours);
        combinedDate.setMinutes(minutes);
        combinedDate.setSeconds(seconds);
        combinedDate.setMilliseconds(seconds * 100);

        return combinedDate.getTime();
    }


    return (
        <div>
            <Card className="h-full w-full">
                <CardHeader variant="gradient" color="gray" className="mt-3 mb-3 p-3 flex flex-row justify-between">
                    <Typography variant="h6" color="white">
                        Advanced Bookings
                    </Typography>
                    <button onClick={() => navigate(`/manager/bookings/create`)} className="px-3 py-1 ml-2 bg-purple-400 rounded hover:bg-purple-600 text-white">
                        Create Booking
                    </button>
                </CardHeader>
                <CardBody className="overflow-scroll px-3 pt-2 pb-2">
                    <CalendarAdvance selectedMonth={selectedMonth} bookings={bookings} onMonthChange={(d) => handleMonthChange(d)} />
                </CardBody>
            </Card>
            <Dialog open={isLoading} className="bg-transparent shadow-none" size="md">
                <DialogBody className="bg-transparent shadow-none flex justify-center">
                    <ClockLoader color="#2be60d" />
                </DialogBody>
            </Dialog>
        </div>
    );
};

export default AdvancedBookingsMonth;